import { useQuery } from '@tanstack/react-query';
import axios from 'config/axios';
import { PurposeIntentTagList } from '../purposeIntent.types';

async function getPurposeIntents(
  purposeId: string
): Promise<PurposeIntentTagList> {
  const response = await axios.get<PurposeIntentTagList>(
    `GetPurposeIntents?purposeId=${purposeId}`
  );

  if (response.status === 204)
    return {
      intentTags: [],
    };

  return response.data;
}

const useGetPurposeIntents = (purposeId: string) =>
  useQuery(
    ['purposeIntentForPurpose', purposeId],
    () => getPurposeIntents(purposeId),
    {
      enabled: purposeId !== '0',
    }
  );

export default useGetPurposeIntents;
